/**
 * SessionStorage-backed store for the Rotaready bearer token the UI attaches
 * to outbound API calls. Written on login, seeded from `VITE_DEV_TOKEN` for
 * local development when no login flow is wired up.
 */

const STORAGE_KEY = 'rotaready.authToken';

/**
 * Returns the current bearer token or `null` when the user is unauthenticated.
 * Reads `sessionStorage` each call so cross-tab changes are visible immediately.
 */
export function getAuthToken(): string | null {
  if (typeof window === 'undefined') return null;
  const stored = window.sessionStorage.getItem(STORAGE_KEY);
  if (stored) return stored;
  const devToken = import.meta.env.VITE_DEV_TOKEN;
  if (typeof devToken === 'string' && devToken.length > 0) {
    window.sessionStorage.setItem(STORAGE_KEY, devToken);
    return devToken;
  }
  return null;
}

/**
 * Persists the token to sessionStorage. Pass `null` to clear.
 */
export function setAuthToken(token: string | null): void {
  if (typeof window === 'undefined') return;
  if (token) {
    window.sessionStorage.setItem(STORAGE_KEY, token);
  } else {
    window.sessionStorage.removeItem(STORAGE_KEY);
  }
}

export function clearAuthToken(): void {
  setAuthToken(null);
}
